import * as i0 from '@angular/core';
import { NgModule, Injectable, inject } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

class AnbCoreModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbCoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: AnbCoreModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbCoreModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: [],
                }]
        }] });

var AnbEnvironmentEnum;
(function (AnbEnvironmentEnum) {
    AnbEnvironmentEnum[AnbEnvironmentEnum["loc"] = 1] = "loc";
    AnbEnvironmentEnum[AnbEnvironmentEnum["dev"] = 2] = "dev";
    AnbEnvironmentEnum[AnbEnvironmentEnum["acc"] = 3] = "acc";
    AnbEnvironmentEnum[AnbEnvironmentEnum["prd"] = 4] = "prd";
    AnbEnvironmentEnum[AnbEnvironmentEnum["tst"] = 5] = "tst";
})(AnbEnvironmentEnum || (AnbEnvironmentEnum = {}));

class CombinedGuardService {
    constructor() {
    }
    async canActivate(route, state) {
        const guards = route.data.guards || [];
        for (const guard of guards) {
            const canActivate = guard;
            let result = canActivate(route, state);
            // Depending on the route result, we may need to await upon it in different ways.
            if (result instanceof Promise) {
                result = await result;
            }
            if (result instanceof Observable) {
                result = await result.toPromise();
            }
            if (result === false || result instanceof UrlTree) {
                return result;
            }
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CombinedGuardService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CombinedGuardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CombinedGuardService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });
const CombinedGuard = (next, state) => {
    return inject(CombinedGuardService).canActivate(next, state);
};

/*
 * Public API Surface of anb-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AnbCoreModule, AnbEnvironmentEnum, CombinedGuard };
